<template>
  <inventoryProductsForm :typeEndPoint="'restaurantProductsShow'" :dataParams="this.$route.params" />
</template>
<script>
import inventoryProductsForm from '@/components/modules/restaurant/products/form'
export default {
  name: 'inventoryProductsEdit',
  components: {
    inventoryProductsForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/restaurant/products/edit.vue